export enum actionTypes {
  SET_AVISO_DATA = 'SET_AVISO_DATA',
  RESET_AVISO_DATA = 'RESET_AVISO_DATA',
  GUARDAR_AVISO_FETCH = 'GUARDAR_AVISO_FETCH',
  GUARDAR_AVISO_SUCCESS = 'GUARDAR_AVISO_SUCCESS',
  GUARDAR_AVISO_ERROR = 'GUARDAR_AVISO_ERROR',
  GUARDAR_AVISO_RESET = 'GUARDAR_AVISO_RESET',
  PUBLICAR_AVISO_FETCH = 'PUBLICAR_AVISO_FETCH',
  PUBLICAR_AVISO_SUCCESS = 'PUBLICAR_AVISO_SUCCESS',
  PUBLICAR_AVISO_ERROR = 'PUBLICAR_AVISO_ERROR',
  PUBLICAR_AVISO_RESET = 'PUBLICAR_AVISO_RESET',
  ACTUALIZAR_AVISO_FETCH = 'ACTUALIZAR_AVISO_FETCH',
  ACTUALIZAR_AVISO_SUCCESS = 'ACTUALIZAR_AVISO_SUCCESS',
  ACTUALIZAR_AVISO_ERROR = 'ACTUALIZAR_AVISO_ERROR',
  ACTUALIZAR_AVISO_RESET = 'ACTUALIZAR_AVISO_RESET',
}

export enum GuardarAvisoStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export enum ActualizarAvisoStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export enum PublicarAvisoStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface AvisoPublicacionState {
  guardarAvisoStatus: GuardarAvisoStatus
  actualizarAvisoStatus: ActualizarAvisoStatus
  publicarAvisoStatus: PublicarAvisoStatus
  avisoData?
  avisoId?
  productoId?
  planPublicacionId?
  paisId?
  error?
}

export interface SetAvisoData {
  type: typeof actionTypes.SET_AVISO_DATA
  payload: { avisoData }
}

export interface ResetAvisoData {
  type: typeof actionTypes.RESET_AVISO_DATA
  payload: null
}

export interface GuardarAvisoFetch {
  type: typeof actionTypes.GUARDAR_AVISO_FETCH
  payload: { avisoData }
}

export interface GuardarAvisoSuccess {
  type: typeof actionTypes.GUARDAR_AVISO_SUCCESS
  payload: { avisoId }
}

export interface GuardarAvisoError {
  type: typeof actionTypes.GUARDAR_AVISO_ERROR
  payload: { error }
}

export interface GuardarAvisoReset {
  type: typeof actionTypes.GUARDAR_AVISO_RESET
  payload: null
}

export interface PublicarAvisoFetch {
  type: typeof actionTypes.PUBLICAR_AVISO_FETCH
  payload: { avisoId; productoId; planPublicacionId; paisId }
}

export interface PublicarAvisoSuccess {
  type: typeof actionTypes.PUBLICAR_AVISO_SUCCESS
  payload: null
}

export interface PublicarAvisoError {
  type: typeof actionTypes.PUBLICAR_AVISO_ERROR
  payload: { error }
}

export interface PublicarAvisoReset {
  type: typeof actionTypes.PUBLICAR_AVISO_RESET
  payload: null
}

export interface ActualizarAvisoFetch {
  type: typeof actionTypes.ACTUALIZAR_AVISO_FETCH
  payload: { avisoData; avisoId }
}

export interface ActualizarAvisoSuccess {
  type: typeof actionTypes.ACTUALIZAR_AVISO_SUCCESS
  payload: { avisoId }
}

export interface ActualizarAvisoError {
  type: typeof actionTypes.ACTUALIZAR_AVISO_ERROR
  payload: { error }
}

export interface ActualizarAvisoReset {
  type: typeof actionTypes.ACTUALIZAR_AVISO_RESET
  payload: null
}

export type AvisoPublicacionActions =
  | SetAvisoData
  | ResetAvisoData
  | GuardarAvisoFetch
  | GuardarAvisoSuccess
  | GuardarAvisoError
  | GuardarAvisoReset
  | PublicarAvisoFetch
  | PublicarAvisoSuccess
  | PublicarAvisoError
  | PublicarAvisoReset
  | ActualizarAvisoFetch
  | ActualizarAvisoSuccess
  | ActualizarAvisoError
  | ActualizarAvisoReset

export const initialState: AvisoPublicacionState = {
  guardarAvisoStatus: GuardarAvisoStatus.Idle,
  actualizarAvisoStatus: ActualizarAvisoStatus.Idle,
  publicarAvisoStatus: PublicarAvisoStatus.Idle,
}
